// import React, { useState } from "react";
import { Card, CardContent, CardMedia, Typography, Grid } from "@mui/material";

export default function VehicleInfoCard({
	bgColor = "white",
	width = "350px",
	selectedVehicle,
}) {
	return (
		<Grid position="relative">
			<Card
				sx={{
					maxWidth: width,
					borderRadius: "20px",
					boxShadow: 1, // shadow 1
					background: bgColor,
					color: "black",
					p: 0, // no card padding
				}}
			>
				<CardMedia
					component="div"
					height="140"
					image={selectedVehicle?.model_image_url}
					alt="Vehicle"
					sx={{
						mt: 2,
						height: 150,
						backgroundImage: `url(${selectedVehicle?.mdl_img_url})`,
						boxShadow: 0, // only image shadow
						backgroundSize: "contain",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center",
					}}
				/>
				<CardContent sx={{ pt: 2 }}>
					<Grid
						container
						spacing={1}
						wrap="nowrap"
						direction="column"
					>
						<Grid xs={12}>
							<Typography variant="h6">
								<strong>Model:</strong> {selectedVehicle?.mdl}
							</Typography>
						</Grid>
						<Grid xs={12}>
							<Typography variant="subtitle2">
								<strong>Chassis #:</strong>{" "}
								{selectedVehicle?.ch_no}
							</Typography>
						</Grid>
						<Grid xs={12}>
							<Typography variant="subtitle2">
								<strong>Dealer:</strong>{" "}
								{selectedVehicle?.dlr_nm}
							</Typography>
						</Grid>
						<Grid xs={12}>
							<Typography variant="subtitle2">
								<strong>City:</strong> {selectedVehicle?.ct}
							</Typography>
						</Grid>
						<Grid xs={12}>
							<Typography variant="subtitle2">
								<strong>State:</strong>{" "}
								{selectedVehicle?.stt_full}
							</Typography>
						</Grid>
						<Grid xs={12}>
							<Typography variant="subtitle2">
								<strong>Installation Date:</strong>{" "}
								{selectedVehicle?.inst_date ?? "-"}
							</Typography>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		</Grid>
	);
}
